/**
 * speakUtils.js
 * ==============
 * On-demand speech synthesis triggered by a user gesture (speaker button tap).
 * Because it runs directly in an event handler, it satisfies browser
 * autoplay/user-activation requirements without any priming tricks.
 *
 * speakSegments(segments)
 *   segments: array of [cue, label?] pairs
 *   e.g. [['Look left for', 'Bathroom'], ['Look up to go back']]
 *
 * Labels are pre-processed: \n → " or " so multi-line option text reads
 * naturally ("Pain or Discomfort" instead of a garbled newline).
 */

const RATE     = 0.82;
const PAUSE_MS = 350;

function makeUtt(text, voice) {
  const u = new SpeechSynthesisUtterance(
    (text || '').replace(/\n/g, ' or ')
  );
  u.rate   = RATE;
  u.pitch  = 1.0;
  u.volume = 1.0;
  if (voice) u.voice = voice;
  return u;
}

export function speakSegments(segments, voiceURI) {
  if (!window.speechSynthesis || !segments.length) return;
  window.speechSynthesis.cancel();

  const voice = voiceURI
    ? (window.speechSynthesis.getVoices().find(v => v.voiceURI === voiceURI) ?? null)
    : null;

  let i = 0;
  function next() {
    if (i >= segments.length) return;
    const [cue, label] = segments[i++];

    if (label) {
      const cueUtt = makeUtt(cue, voice);
      cueUtt.onend = () => {
        setTimeout(() => {
          const labelUtt = makeUtt(label, voice);
          labelUtt.onend = next;
          window.speechSynthesis.speak(labelUtt);
        }, PAUSE_MS);
      };
      window.speechSynthesis.speak(cueUtt);
    } else {
      const u = makeUtt(cue, voice);
      u.onend = next;
      window.speechSynthesis.speak(u);
    }
  }
  next();
}
